import React from 'react';
import { ENUM_PROCUREMENT_STATUS } from 'models/procurement.model';
import { PROCUREMENT_STATUS_TAG } from 'utils/constants';

const ProcurementStatusTag = ({ type }: { type: ENUM_PROCUREMENT_STATUS }) => {
  const { textColor, bgColor, text } = PROCUREMENT_STATUS_TAG[type];
  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor
      }}
      className={`flex items-center gap-1 capitalize rounded-[40px] font-medium text-xs leading-[19px] px-3 py-1`}>
      <p
        className='w-[8px] h-[8px] rounded-full'
        style={{
          backgroundColor: textColor
        }}
      />
      {text}
    </div>
  );
};

export default ProcurementStatusTag;
